import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './../assets/logo.png'
import _imports_1 from './../assets/info.png'
import _imports_2 from './../assets/more.png'
import _imports_3 from './../assets/less.png'
import _imports_4 from './../assets/check.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "ambiFOX Logo",
  src: _imports_0,
  class: "bild"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Hungry? Order!", -1)
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  alt: "menue card",
  src: _imports_1,
  class: "btn btn--min-b-radius"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("a", {
      href: _ctx.url,
      target: "_blank"
    }, _hoisted_5, 8, _hoisted_3),
    _hoisted_6,
    _createElementVNode("p", null, [
      _createTextVNode(" Please choose your amount of meals for "),
      _hoisted_7,
      _createElementVNode("strong", null, _toDisplayString(_ctx.next_possible_order_date.toDateString()), 1)
    ]),
    _createElementVNode("p", null, [
      _createTextVNode(" Amount: "),
      _createElementVNode("strong", null, _toDisplayString(_ctx.order_amount), 1)
    ]),
    _createElementVNode("img", {
      class: "btn",
      alt: "more",
      src: _imports_2,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.increaseAmount && _ctx.increaseAmount(...args)))
    }),
    _createElementVNode("img", {
      class: "btn",
      alt: "less",
      src: _imports_3,
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.decreaseAmount && _ctx.decreaseAmount(...args)))
    }),
    _hoisted_8,
    _hoisted_9,
    _createElementVNode("img", {
      class: "btn",
      alt: "order",
      src: _imports_4,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.placeOrder && _ctx.placeOrder(...args)))
    })
  ]))
}